const prefix = '/me';

export const ApiSubscriptionUrls = {
  me: `${prefix}/subscription`,
};
